import { TagIcon } from '@heroicons/react/24/outline'
import NewClassifierButton from './NewClassifierButton'

/**
 * Two empty states in one: an unfiltered library is an invitation to create the first
 * classifier, whereas a filtered one is a dead end the admin should back out of — so
 * only the former offers the create action.
 */
export default function ClassifierLibraryEmpty({ filtered }: { filtered: boolean }) {
    return (
        <div className="rounded-lg border border-ink-200 bg-white py-16 text-center">
            <TagIcon className="mx-auto h-10 w-10 text-ink-300" aria-hidden="true" />
            <p className="mt-3 text-sm text-ink-500">
                {filtered ? 'No classifiers match your filters.' : 'No classifiers yet.'}
            </p>
            {!filtered && <NewClassifierButton className="mt-4 inline-flex" />}
        </div>
    )
}
